import React from "react";
import CityList from "./PlaceNotFound";
import Icon from "./Icon";
import { DataShape } from "../shapes";
import NearbySpaces from "./NearbySpaces";
import NearbyLocations from "./NearbyLocations";
import { Subscribe } from "unstated";
import SrpContainer from "../containers/SrpContainer";
import NoSrpContact from "./NoSrpContact";

const TooManyPages = ({ data: { pages, page, base_srp: baseSrp } }) => (
  <div className="ux-no-results-page">
    <div className="ux-circle-large">
      <Icon c="icon icon-search" i="search" />
    </div>

    <p className="no-srp-head-title">
      Your search criteria will only return {pages} page{pages === 1 ? "" : "s"}
      . This page is {page - pages} page{page - pages === 1 ? "" : "s"} too far.
    </p>

    <a href={baseSrp}>Go to the search results</a>

    <NoSrpContact />

    <NearbySpaces />

    <NearbyLocations />

    <CityList />
  </div>
);

TooManyPages.propTypes = {
  data: DataShape.isRequired,
};

const TooManyPagesContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({ state: { data } }) => <TooManyPages data={data} />}
  </Subscribe>
);

export default TooManyPagesContainer;
